// extracted by css-extract-rspack-plugin
export default {"srOnly":"ShQfc"};